import { render, staticRenderFns } from "./LayerassocTab.vue?vue&type=template&id=1543a87d"
import script from "./LayerassocTab.vue?vue&type=script&lang=js"
export * from "./LayerassocTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports